import PawModel from './PawModel';
import axios from 'axios'

class Space extends PawModel {
  static apiType = 'spaces';

  title?: string;

  static filters: {
    id?: string;
    created_at?: string;
    updated_at?: string;
    title?: undefined | string;
    weight?: undefined | string;
  } = {
    id: '',
    created_at: '',
    updated_at: '',
    title: '',
    weight: ''
  }

  async addDocs(doc_ids: string[]) {
    await axios.post(`/api/d1/spaces/${this.id}/add_docs`, { doc_ids });
  }
}

export default Space;
